import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  imagen: {
    width: 50,
  },
});
function Logo(props) {
  const classes = useStyles();

  return (
    <img
      alt="Logo"
      src="/static/logo.png"
      className={props.classesProps || classes.imagen}
      {...props}
    />
  );
}

export default Logo;
